import React, { useState, useEffect } from 'react';
import { makeStyles, CircularProgress } from '@material-ui/core';
import Store from 'store/store';
import { errHelper, formatPercent } from 'utils';
import { BoxWrapper } from 'components/Base';
import api from 'api';
import Router from 'components/Router/Router';
import { useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    marginTop: '1rem'
  },
  color: {
    width: '17px',
    height: '37px'
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    margin: '2px'
  },
  name: {
    marginLeft: '1rem'
  },
  valueBox: {
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '2rem'
  },
  paper: {
    margin: 0,
    marginTop: '28px'
  },
  loaderWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }
});

const { useParams } = Router;
const { connect, selectors } = Store;

interface AssetAllocationsProps {
  riskSummary: {
    timeHorizon: number;
    recommendedRiskProfile: number;
  };
}
const AssetAllocations = ({ riskSummary }: AssetAllocationsProps) => {
  const theme = useTheme() as any;
  const [isLoadingAssets, setIsLoadingAssets] = useState(false);
  const [allocations, setAllocations] = useState([]);

  const { portfolio } = useParams() as any;
  const classes = useStyles();
  const { timeHorizon, recommendedRiskProfile } = riskSummary;

  useEffect(() => {
    setIsLoadingAssets(true);
    api
      .getTypicalAssetAllocationEvalue({
        portfolio,
        recommendedRiskProfile: recommendedRiskProfile,
        timeHorizon: timeHorizon
      })
      .then(({ data }) => {
        const preparedData = data.map((allocation: any) => ({
          name: allocation.name,
          value: Number(allocation.allocation) * 100
        }));
        setAllocations(preparedData);
        setIsLoadingAssets(false);
      })
      .catch((err: any) => {
        errHelper(err);
        setIsLoadingAssets(false);
      });

    // eslint-disable-next-line
  }, [timeHorizon, recommendedRiskProfile]);
  return (
    <BoxWrapper
      title="Typical Asset Allocation"
      tooltip="Asset allocation determined by specified time horizon and recommended risk profile."
      className={classes.paper}
      headerChildren={
        <div className={classes.loaderWrapper}>
          {isLoadingAssets && <CircularProgress size="20px" />}
        </div>
      }
    >
      <div style={{ padding: '1rem' }}>
        {allocations.map((alloction: any, index: number) => {
          return (
            <div key={alloction.name} className={classes.box}>
              <div
                className={classes.color}
                style={{
                  backgroundColor:
                    theme.palette.baseColors.charts['asset-allocation'][index]
                }}
              />
              <span className={classes.name}>{alloction.name}</span>
              <div className={classes.valueBox}>
                <span>{formatPercent(alloction.value)}</span>
              </div>
            </div>
          );
        })}
      </div>
    </BoxWrapper>
  );
};

export default connect((state: any) => ({
  riskSummary: selectors.portfolioBuilderSelectors.riskSummary(state)
}))(AssetAllocations);
